import { render, staticRenderFns } from "./cpt-carousel.vue?vue&type=template&id=21416bc2&scoped=true"
import script from "./cpt-carousel.vue?vue&type=script&lang=js"
export * from "./cpt-carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21416bc2",
  null
  
)

export default component.exports